import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const APP_LOADED_SCHEMA = Object.freeze({
  TIME_TO_FIRST_PAINT: '',
  TIME_TO_APP_LOAD: '',
  TIME_TO_INTERACTIVE: '',
});
const RECORD = generateSchema(APP_LOADED_SCHEMA);
const KEYS: any = generateKeys(APP_LOADED_SCHEMA);

export class AppLoadedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.app_loaded;
  }

  get properties() {
    return this.toJS();
  }
}
